import React from "react";
import "./index.scss";

import { connect } from "react-redux";
const mapStateToProps = (state) => ({
  tenant: state.getIn(["tenantReducer", "tenant"]),
});
const ReOrderDes = (props) => {
  return (
    <div className="page">
      <div className="top"></div>
      <div className="content">
        <div className="list">
          <div className="card">
            <h1>什么是预约单？</h1>
            <p>
              预约单时乘客不是当时用车，需要您按照订单上设置的用车时间到达上车点接驾。
            </p>
            <p>您在预约单开始服务前的40分钟内是无法听单的，感谢您的支持。</p>
          </div>
          <div className="card">
            <h1>如何设置预约单？</h1>
            <p>
              在首页点击“预约单”入口，在预约单页面中打开预约单的开关，打开开关后，有预约单时系统将会通过播报的方式发送预约单。
            </p>
          </div>
          <div className="card">
            <h1>预约单容易被判责的场景？</h1>
            <p>1、司机提前点击“到达上车点”；</p>
            <p>2、司机到达乘客上车点等候时间不足；</p>
            <p>3、司机无正当理由迟到；</p>
            <p>4、司机未到达指定上车点取消订单；</p>
            <p>5、无正当理由，司机未按平台要求提供服务；</p>
            <p>6、诱导乘客取消订单；</p>
            <p>7、司机要去加价议价；</p>
            <p>8、司机无正当理由多次未接乘客电话。</p>
          </div>
        </div>
      </div>
      <div className="bottom"></div>
    </div>
  );
};
export default connect(mapStateToProps)(ReOrderDes);
